export default "/images/6cc6781e78d87a7932ae42da7b95877e.avif";